import React, { useState } from 'react';
import { IconButton, Popover, Stack, Typography } from '@mui/material';
import StarsIcon from '@mui/icons-material/Stars';

const MARKER_INFO_TEXT =
    'This icon indicates that this is your self-marked scores. These are not official but are critical to prevent incorrect scores and undue penalties.';

export const MarkerScoreInfo = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setAnchorEl((current) => (current ? null : event.currentTarget));
    };

    const handleClose = () => setAnchorEl(null);

    return (
        <>
                <Stack alignItems="center" spacing={0} sx={{ flexShrink: 0, overflow: 'visible' }}>
                <IconButton
                    size="small"
                    aria-label="Marker score info"
                    aria-expanded={open}
                    onClick={handleToggle}
                    sx={{ p: 0.25 }}
                >
                    <StarsIcon sx={{ width: 20, height: 20, color: 'green' }} />
                </IconButton>
                <Typography
                    variant="caption"
                    fontStyle="italic"
                    sx={{ color: 'green', lineHeight: 1, fontSize: 10, textAlign: 'center' }}
                >
                    Marker
                </Typography>
            </Stack>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                disableScrollLock
                sx={{ zIndex: (theme) => theme.zIndex.modal }}
                slotProps={{
                    paper: {
                        sx: {
                            p: 2,
                            maxWidth: 280,
                            backgroundColor: 'sepia.background',
                            border: '1px solid',
                            borderColor: 'sepia.extraLight',
                            borderRadius: 2,
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
                        },
                    },
                }}
            >
                <Stack alignItems="center" spacing={1}>
                    <StarsIcon sx={{ width: 24, height: 24, color: 'green' }} />
                    <Typography variant="body2" sx={{ textAlign: 'center', color: 'sepia.dark' }}>
                        {MARKER_INFO_TEXT}
                    </Typography>
                </Stack>
            </Popover>
        </>
    );
};
